import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import StoreDetailImage from './StoreDetailImage.js';

const StoreDetailImageContainer = (_param)=>{
    var { alt , detailImageUrl , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "alt",
        "detailImageUrl",
        "fallbackImage"
    ]);
    const url = detailImageUrl || (fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.url);
    if (!url) {
        return null;
    }
    var ref;
    const altText = !detailImageUrl ? (ref = fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.description) !== null && ref !== void 0 ? ref : alt : alt;
    return /*#__PURE__*/ React.createElement(StoreDetailImage, swcHelpers.extends({}, rest, {
        storeDetailImageUrl: url,
        isFallbackImage: !detailImageUrl,
        width: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.width : undefined,
        height: !detailImageUrl ? fallbackImage === null || fallbackImage === void 0 ? void 0 : fallbackImage.height : undefined,
        alt: altText
    }));
};

export { StoreDetailImageContainer as default };
//# sourceMappingURL=StoreDetailImageContainer.js.map
